import React, { Component, useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import AttachmentsComponent from "../../components/Attachments";
import {
  caseStatusInitialPagination,
  ersInitialPagination,
  initialPagination,
} from "../../App.config";
import { useLocation } from "react-router-dom";
import history from "../../utilities/history";
import CaseStatusComponent from "../../components/CaseStatus";
import * as managerApplicantActions from "../../redux/actions/managerApplicantAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const CaseStatus = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const attachmentsReducer = useSelector((state) => state.attachmentsReducer);
  const managerApplicationReducer = useSelector(
    (state) => state.managerApplicantReducer
  );
  const dispatch = useDispatch();
  let stdAction = bindActionCreators(stdActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);
  const managerApplicantAction = bindActionCreators(
    managerApplicantActions,
    dispatch
  );

  //Set initial pagination and call api after first render
  // useEffect(() => {
  //   managerApplicantAction.setCaseStatusCurrentPage(
  //     caseStatusInitialPagination.pageNo
  //   );
  //   managerApplicantAction.setCaseStatusPageSize(
  //     caseStatusInitialPagination.pageSize
  //   );
  //   managerApplicantAction.getCaseStatus(null, caseStatusInitialPagination);
  // }, []);

  ///Set initial pagination and call api after first render
  useEffect(() => {
    attachmentsAction.setCurrentPage(initialPagination.pageNo);
    attachmentsAction.setPageSize(initialPagination.pageSize);
    managerApplicantAction.getEmployeebyManager(ersInitialPagination, null, profileReducer);
    return () => {
      managerApplicantAction.setCurrentPage(ersInitialPagination.pageNo);
      managerApplicantAction.setPageSize(ersInitialPagination.pageSize);
    };
  }, []);

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };
  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onPageSizeChange = (pageSize) => {
    managerApplicantAction.getEmployeebyManager(
      {
        pageNo: ersInitialPagination.pageNo,
        pageSize: pageSize,
        totalRows: managerApplicationReducer.totalRows,
      },
      null,
      profileReducer
    );
    managerApplicantAction.setCurrentPage(ersInitialPagination.pageNo);
    managerApplicantAction.setPageSize(pageSize);
  };

  const onChange = (page) => {
    managerApplicantAction.setCurrentPage(page.value);
    managerApplicantAction.getEmployeebyManager(
      {
        pageNo: page.value,
        pageSize: managerApplicationReducer.pageSize,
        totalRows: managerApplicationReducer.totalRows,
      },
      null,
      profileReducer
    );
  };

  const setCaseStatusModified = (modifiedCaseStatus) => {
    managerApplicantAction.setCaseStatusModified(modifiedCaseStatus);
  };

  const getSearchCaseStatus = (searchKey) => {
    managerApplicantAction.getEmployeebyManager(ersInitialPagination, searchKey, profileReducer);
    managerApplicantAction.setCurrentPage(ersInitialPagination.pageNo);
    managerApplicantAction.setPageSize(ersInitialPagination.pageSize);
  };
  return (
    <>
      <ShowForPermission module={PERMISSON_MODULES.CASE_DETAILS} permission={PERMISSION_TYPE.VIEW}>
        <CaseStatusComponent
          context={props.context}
          caseStatusDetails={managerApplicationReducer.applicants}
          setCaseStatusModified={setCaseStatusModified}
          onPageSizeChange={onPageSizeChange}
          getSearchCaseStatus={getSearchCaseStatus}
          isCustomAttachment={attachmentsReducer.isCustomAttachment}
          attachmentData={attachmentsReducer.attachments}
          currentPage={managerApplicationReducer.currentPage}
          pageSize={managerApplicationReducer.pageSize}
          totalRows={managerApplicationReducer.totalRows}
          onChange={(props) => {
            onChange(props);
          }}
        />
      </ShowForPermission>
    </>
  );
};

export default CaseStatus;
